import {Component, Input} from '@angular/core';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-titan-pill',
  templateUrl: './titan-pill.component.html',
  styleUrls: ['./titan-pill.component.scss'],
  imports: [
    NgClass
  ],
  standalone: true,
})
export class TitanPillComponent {

  @Input() state: string = 'default';

}
